import dayjs from "dayjs";
import * as S from "./CommentItem.style";
import { StudentCheerMessage } from "@/common/types/cheerMessage";

interface CommentItemProps {
  data: StudentCheerMessage;
  onClick?: any;
}

export const CommentItem = ({ data, onClick }: CommentItemProps) => {
  return (
    <S.CommentItem
      onClick={onClick && onClick}
      $linked={onClick ? true : false}
    >
      <S.CommentText>
        {/* {data.isRead ? (
          // <span>{data.isRead ? "내용확인" : "전송완료"}</span>
          <span>전송완료</span>
        ) : (
          <span>보호자 {data.writer} 님</span>
        )} */}
        <span>보호자 {data.writer} 님의 메시지</span>
        {data.content}
      </S.CommentText>

      <S.CommentDate>
        {data.createdAt
          ? dayjs(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
          : ""}
      </S.CommentDate>
    </S.CommentItem>
  );
};
